//#region src/math/clamp.ts
function e(e, t, n) {
	return t != null && e < t ? t : n != null && e > n ? n : e;
}
//#endregion
export { e as clamp };

//# sourceMappingURL=clamp.js.map